// Fallback only. The live list comes from GET /dashboard/categories via
// useCategories(). Do not add values here — add them in the admin
// Categories tab, or this copy drifts again.
export const CATEGORY_MAP: Record<string, string[]> = {
  "Student": [
    "Student Travel & Research Support",
    "Student Activities & Clubs",
    "Health, Wellness & Wellbeing",
    "Scholarships & Financial Aid",
    "Student Living & Accommodation Support",
    "Research Fellowships & Grants",
    "Student Prizes & Awards",
    "Internships & Industry Exposure"
  ],
  "Faculty": [
    "Endowed Chairs & Professorships",
    "Faculty Fellowships & Research Grants",
    "Faculty Awards & Recognition",
    "Faculty Mobility & Industry Engagement (Externships)",
    "New Faculty Recruitment & Start-up Support"
  ],
  "Research": [
    "Interdisciplinary Research Projects (Centers of Excellence)",
    "Faculty-Led Research Projects",
    "Center & Laboratory Research Projects",
    "School-Level Research Initiatives",
    "External Training & Skilling Programs",
    "Research Events, Workshops & Conferences"
  ],
  "Infrastructure": [
    "Buildings & Campus Development",
    "Equipment & Scientific Infrastructure",
    "Mobility & Transport Infrastructure",
    "Operational & Support Infrastructure"
  ],
  "Inovation and Entrepreneurship": [
    "Innovation, Incubation & Entrepreneurship Centers",
    "Student Innovation & Entrepreneurship Programs"
  ],
  "Internationalisation": [
    "International Student Scholarships & Financial Support",
    "Global Collaboration & International Infrastructure"
  ],
  "Institutional Alumini Engagement": [
    "Alumni Engagement & Reunions",
    "Department Development Funds",
    "Department Events & Programs",
    "Lecture Series & Distinguished Talks",
    "Naming Opportunities",
    "Alumni Office & Outreach Support",
    "Unrestricted/General Funds"
  ]
};
